import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class DateValidator {
    static NotLowerThanCurrentDateTime(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const selectedDateTime = control.value as Date;

            const lowerThanCurrent = selectedDateTime < new Date();
            return lowerThanCurrent ? { notLowerThanCurrentDateTime: { value: control.value } } : null;
        };
    }
}
